/*
 * Comutatorul de limba.
 *
 * Un `<select>` nativ, nu un meniu desenat de noi: are deja tot ce trebuie -
 * tastatura, cititoare de ecran, comportamentul asteptat pe telefon - iar
 * pentru doua optiuni nu merita scris nimic pe deasupra.
 *
 * Sta jos in bara laterala, langa contul omului. Acolo stau lucrurile despre
 * TINE, nu despre catalog, iar limba e unul dintre ele. Sus, langa titlu, ar fi
 * concurat cu navigatia pentru atentie de fiecare data cand cineva deschide
 * pagina, pentru o setare atinsa o data.
 */

import { getLang, setLang, t, type Lang } from '../lib/i18n';

export function LangSwitch({ onChange }: { onChange: () => void }) {
  return (
    <label className="langswitch">
      <span className="sr-only">{t('Language')}</span>
      <select
        className="langswitch__select"
        value={getLang()}
        onChange={(event) => {
          setLang(event.target.value as Lang);
          /* Parintele remonteaza arborele. Vezi lib/i18n.ts pentru de ce. */
          onChange();
        }}
      >
        <option value="ro">Română</option>
        <option value="en">English</option>
      </select>
    </label>
  );
}
